import { useAtomValue } from 'jotai';
import { configAtom } from '../atoms/configAtoms';

const useConfig = () => {
    const config = useAtomValue(configAtom);
    return config;
};

export default useConfig;
